import { Component, OnInit } from '@angular/core';

import { PcvizCRP1FileData, PcvizCRP1ScanData, PcvizCRP1ScanProjectJobAdapter } from '@mirage-projects/cw-models';
import { JobPcvizService } from '@mirage-projects/cw-pcviz-core';

import { UploadWizardService } from '../../services/upload-wizard-service/upload-wizard.service';

/**
 * Scan selection tree for the import crp1 stations workflow
 */
@Component({
    selector: 'cw-crp1-scan-select',
    templateUrl: 'crp1-scan-select.component.html',
    styleUrls: ['crp1-scan-select.component.scss'],
    standalone: false,
})
export class Crp1ScanSelectComponent implements OnInit {
    private jobAdapter!: PcvizCRP1ScanProjectJobAdapter;

    constructor(
        private uploadWizardService: UploadWizardService,
        private jobAdapterService: JobPcvizService
    ) {}

    ngOnInit(): void {
        this.jobAdapter = this.jobAdapterService.getJobAdapter() as PcvizCRP1ScanProjectJobAdapter;
    }

    setSelectedScans(scans: PcvizCRP1ScanData[]): void {
        this.jobAdapter.setScans(scans);
        this.updateSummary();
    }

    get fileData(): PcvizCRP1FileData | undefined {
        const { fileData } = this.uploadWizardService;
        if (!fileData) {
            return;
        }
        return this.sortFileData(fileData);
    }

    private sortFileData(fileData: PcvizCRP1FileData): PcvizCRP1FileData {
        fileData.content.projects.forEach((project) =>
            project.scans.sort((scanA, scanB) => new Date(scanB.captureDate).getTime() - new Date(scanA.captureDate).getTime())
        );

        fileData.content.projects.sort((projectA, projectB) => {
            const dateA = new Date(projectA.scans?.[0]?.captureDate ?? 0).getTime();
            const dateB = new Date(projectB.scans?.[0]?.captureDate ?? 0).getTime();
            return dateB - dateA;
        });

        return fileData;
    }

    private updateSummary(): void {
        const wizard = this.uploadWizardService.wizard;
        const summary = this.uploadWizardService.summary;
        const scans = this.jobAdapter.getScans() ?? [];
        const scansCount = scans.length;

        const fileData = this.uploadWizardService.fileData;
        const projects = (fileData && fileData.content && fileData.content.projects) || [];

        const selectedProjects = projects.filter((project) => (project.scans || []).some((scan) => scans.includes(scan)));
        const projectsCount = selectedProjects.length;

        summary[wizard.selectedIndex] = {
            title: 'WIZARD.TAB_CRP1_SCAN_SELECTOR',
            fields: [
                { key: 'SCANPROC.SCAN_IMPORT_TOTAL_PROJECTS', value: `${projectsCount}` },
                { key: 'SCANPROC.SCAN_IMPORT_TOTAL_SCANS', value: `${scansCount}` },
            ],
        };
    }
}
